const rules = {
	user: {
		static: [],
	},

	// Operador: tudo que o admin faz, menos criar/excluir usuarios, editar
	// perfil de alguem, o Link do SMS e as telas de Fluxos Visuais e Chatbot IA.
	// Conexoes: ve, adiciona, remove, conecta/desconecta (14/out/2026).
	operador: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
			"contacts-page:export",
			"tags-page:manage",
		],
	},

	admin: {
		static: [
			"drawer-admin-only:view",
			"users-page:manage",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
			"contacts-page:export",
			"tags-page:manage",
		],
	},
};

export default rules;
